// Bê từ finiva-admin settings/lib/sections.ts. Sửa: chỉ giữ Tài khoản + Hiển thị & mặc định (bỏ Thông báo, Tập đoàn, Cảnh báo,
// Kế toán – admin không có); bỏ điều kiện thuộc tập đoàn (needsTenant)
import { LayoutGrid, UserRound, type LucideIcon } from 'lucide-react'
import type { CurrentUser } from '@modules/auth/types'

export type SettingsSectionId = 'account' | 'display'

export interface SettingsSectionDef {
  id: SettingsSectionId
  label: string
  hint: string
  block: 'mine'
  icon: LucideIcon
  /** tài nguyên cần có trong accessibleResources; null = ai cũng thấy */
  resource: string | null
}

/** Danh sách nhóm của trang Cài đặt — thêm nhóm: thêm dòng ở đây + nhánh trong `SettingsSectionRoute` */
export const SETTINGS_SECTIONS: readonly SettingsSectionDef[] = [
  {
    id: 'account',
    label: 'Tài khoản',
    hint: 'Thông tin, mật khẩu, phiên đăng nhập',
    block: 'mine',
    icon: UserRound,
    resource: null,
  },
  {
    id: 'display',
    label: 'Hiển thị & mặc định',
    hint: 'Mật độ bảng, số dòng mỗi trang, trang mở đầu',
    block: 'mine',
    icon: LayoutGrid,
    resource: null,
  },
]

export const BLOCK_LABEL = { mine: 'Của tôi' } as const

export function visibleSections(user: CurrentUser | null): SettingsSectionDef[] {
  if (!user) return []
  return SETTINGS_SECTIONS.filter(
    (s) => !s.resource || !!user.accessibleResources?.includes(s.resource),
  )
}

export const settingsPath = (id: SettingsSectionId) => `/settings/${id}`
